var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Group } from '@/models/Group';
import GraduationProfileSelect from '@/components/GraduationProfileSelect/GraduationProfileSelect.vue';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import { GraduationProfile } from '@/models/GraduationProfile';
import ErrorHandler from '@/support/ErrorHandler';
let AttachGraduationProfileDialog = class AttachGraduationProfileDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedStudents = {};
        this.studentsToDisplay = [];
        this.completeProfile = null;
        this.profileId = '';
        this.currentStep = 1;
        this.isLoading = true;
        // #endregion
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select students'), value: 1 },
                { label: this.$tc('Select graduation profile'), value: 2 },
                { label: this.$tc('createDialog.header.finished'), value: 3 },
            ],
            title: this.$tc('Attach graduation profile'),
            customButtons: [
                {
                    label: this.$tc('Attach'),
                    action: () => this.onSubmit(),
                    visible: this.currentStep === 3,
                },
            ],
        };
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onReset() {
        this.selectedStudents = {};
        this.studentsToDisplay = [];
        this.completeProfile = null;
        this.profileId = '';
        this.currentStep = 1;
    }
    onClose() {
        this.onReset();
        this.$emit('close');
    }
    onSelectedStudents(value) {
        this.$set(this, 'selectedStudents', value);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
    }
    getStudents() {
        if (!this.selectedStudents || !Object.keys(this.selectedStudents).length) {
            return;
        }
        const students = this.group.users;
        if (!students || !students.length) {
            return;
        }
        const studentIds = Object.keys(this.selectedStudents).filter((key) => this.selectedStudents[key]);
        this.studentsToDisplay = Array.isArray(students)
            ? students.filter((student) => student.id !== undefined && studentIds.includes(student.id))
            : [];
    }
    // #endregion
    // #region Async methods (api calls only)
    async onSubmit() {
        if (!this.completeProfile) {
            return;
        }
        const studentIds = Object.keys(this.selectedStudents).filter((key) => this.selectedStudents[key]);
        await this.completeProfile.attachStudents(studentIds, false);
        this.onReset();
        this.$emit('submitted');
    }
    async fetchGraduationProfiles() {
        if (!this.profileId || !this.profileId.trim().length) {
            return;
        }
        this.isLoading = true;
        try {
            this.completeProfile = await new GraduationProfile().find(this.profileId);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get getSelectedStudentText() {
        if (!this.studentsToDisplay || !this.studentsToDisplay.length) {
            return '-';
        }
        if (this.studentsToDisplay.length === 1) {
            return this.studentsToDisplay[0].name;
        }
        return this.studentsToDisplay.map((student) => student.name).join(', ');
    }
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return (Object.keys(this.selectedStudents).every((key) => {
                    return this.selectedStudents[key] === false;
                }) || Object.keys(this.selectedStudents).length === 0);
            case 2:
                return !this.profileId || this.profileId.trim().length === 0;
            default:
                return false;
        }
    }
    // #endregion
    // #region @Watchers
    async onCurrentStepChangedWatcher(value) {
        if (value === 3) {
            this.getStudents();
            await this.fetchGraduationProfiles();
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], AttachGraduationProfileDialog.prototype, "group", void 0);
__decorate([
    Watch('currentStep'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], AttachGraduationProfileDialog.prototype, "onCurrentStepChangedWatcher", null);
AttachGraduationProfileDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            GraduationProfileSelect,
            StudentSelector,
            LabelValue,
        },
    })
], AttachGraduationProfileDialog);
export default AttachGraduationProfileDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
